import React, { useEffect, useState } from 'react'
import { tabelStyles, TopTabStyle, tabStyle, h5Style, activeTabStyle } from '../css/styles/componentStyles';
import { transactionPopupStyle } from '../css/styles/componentStyles';
import "../css/classes/csvButton.css"
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import SortIcon from '@mui/icons-material/Sort';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import { addTransactionCsvFile, getAllCredTransactions, getAllCredTransactionsByFilter, getAllCredTransactionsByMonth, getAllCredTransactionsBySearch, getAllDescription, getAllExpenses, getAllSubCategory, getSortedCredTransactions, getTransactionMapping, saveCategoryForTransaction } from '../utils/ActionCreator';
import AddBoxIcon from '@mui/icons-material/AddBox';
import SpinnerLoader from '../../../../../../presentationals/Loader/Loader.component';
// import SpinnerLoader from '../../../../Common/Loader.component';
import { transactionSideTabs } from '../utils/string';
import { X } from '@mui/icons-material';
import UploadCsv from '../components/uploadCsv/uploadCsv';
// const filterOptions = ["Bills", "Debts", "Expenses", "Income", "Savings"];
const filterOptions = ["Expenses", "Income"];
const sortOptions = ["Category", "Date", "Type", "Amount", "Detail"];

function TransactionScreen({ monthlyTab }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeFilter, setActiveFilter] = useState("");
  const [activeSort, setActiveSort] = useState("");
  const [tab, setTab] = useState("all");
  const [allTransactions, setAllTransactions] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [allDescription, setAllDescription] = useState([]);
  const [allSubCategory, setAllSubCategory] = useState([]);
  const [showPoup, setShowPoup] = useState(false);
  const [showUploadCsv, setShowUploadCsv] = useState(false);
  const [loader, setLoader] = useState(false);
  const [inputDescription, setInputDescription] = useState('');
  const [expenseCycle, setExpenseCycle] = useState('');

  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const [selectedDescription, setSelectedDescription] = useState("");

  const clearSearch = () => setSearchTerm("");

  const validPopupData = () => {
    if (selectedCategory === "") {
      return false;
    }
    else if (selectedSubcategory === "") {
      return false;
    }
    else if (selectedDescription === "") {
      return false;
    }else if(selectedDescription === "other" && (inputDescription ==="" || expenseCycle === "")){
      return false;
    } else {
      return true;
    }
  }

  const handleSearchText = (value) => {
    if (loader) {
      return;
    }

    const currentLength = value.length;
    const previousLength = searchTerm.length;

    console.log(currentLength, previousLength);

    if (currentLength > 3) {
      setSearchTerm(value);
      setActiveSort("");
      setActiveFilter("")
      setLoader(true);
      getAllCredTransactionsBySearch(
        value,
        (callback) => {
          if (callback.status === 200) {
            setAllTransactions(callback.data);
          }
          setLoader(false);
        },
        (onErr) => {
          setLoader(false);
        }
      );
    } else if (currentLength === 3 && previousLength === 4) {
      setActiveSort("");
      setActiveFilter("")
      setSearchTerm(value);
      filterData();
    } else {
      setSearchTerm(value);
    }
  };


  const clearFields = () => {
    setSelectedCategory("");
    setSelectedSubcategory("");
    setSelectedDescription("");
    setSelectedItem("");
    setInputDescription("");
    setExpenseCycle("");
  }

  const setActiveFilterValue = (value) => {
    if(loader){
      return;
    }
    setActiveSort("");
    setTab("all")
    if (value === activeFilter) {
      setActiveFilter("")
      filterData();
    } else {
      setActiveFilter(value);
      setLoader(true);
      getAllCredTransactionsByFilter(value === "Expenses" ? true :false,(callback)=>{
        if (callback.status === 200) {
          setAllTransactions(callback.data);
        }
        setLoader(false);
      },(onErr)=>{
        setLoader(false);
      });

    }
  }

  useEffect(() => {
    filterData(monthlyTab)
  }, [monthlyTab]);

  const filterData = (monthlyTab) => {
    setLoader(true);
    if (monthlyTab && monthlyTab !== "") {
      getAllCredTransactionsByMonth(monthlyTab, (callback) => {
        if (callback.status === 200) {
          setAllTransactions(callback.data);
        }
        setLoader(false)
      }, (err) => {
        setLoader(false)
      });
    } else {
      getAllCredTransactions((callback) => {
        console.log("data", callback);
        if (callback.status === 200) {
          setAllTransactions(callback.data);
        }
        setLoader(false)
      }, (onError) => {
        console.log("error", onError);
        setLoader(false)
      });
    }
  }

  useEffect(() => {
    if (allCategories.length < 1) {
      getAllExpenses((callback) => {
        if (callback.status === 200) {
          setAllCategories(callback.data);
        }
      }, (onErr) => { });
    }
  }, [])

  const saveCategory = () => {
    setLoader(true);
    console.log("selectedItem",selectedItem);
    var payload = {
      transactionId: selectedItem.transctionId,
      categoryId: selectedCategory,
      subCategoryId: selectedSubcategory,
      descriptionId:selectedDescription === "other"?"": selectedDescription,
      description: selectedDescription === "other" ? inputDescription:null,
      expenseCycle: selectedDescription === "other" ?expenseCycle:null
    };
    saveCategoryForTransaction(payload, (callBack) => {
      setLoader(false);
      setShowPoup(false);
      // Refresh data after saving
      filterData(monthlyTab);
      clearFields();
      alert("Successfully Mapped")
    }, (onErr) => {
      setLoader(false);
      alert("Failed to change category");
    });

    console.log("payload", payload);
  }

  const setActiveSortValue = (value, dataType) => {
    if (loader) {
      return;
    }
    setTab("all")
    if (value !== null && value === activeSort && dataType === null) {
      setActiveSort("")
      filterData();
    } else if (value === "" && dataType !== null) {

    }
    else {
      if (value !== null && value !== "") setActiveSort(value);
      setLoader(true)
      getSortedCredTransactions(value, dataType ?? "desc", (callback) => {
        if (callback.status === 200) {

          setAllTransactions(callback.data);
        }
        setLoader(false)
      }, (onError) => {
        setLoader(false)
      });



    }
  }

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
    setSelectedSubcategory("");
  };

  const handleSelectedItem = (item) => {
    console.log(item)
    if ((item?.category === null || item?.subCategory === null || item?.description === null) && item.transctionId && item.transctionId !== "") {

      setSelectedItem(item)
      setShowPoup(true);
    }

  }

  useEffect(() => {
    if (allSubCategory.length < 1) {
      getAllSubCategory((callback) => {
        if (callback.status === 200) {
          setAllSubCategory(callback.data);
        }
      }, (onErr) => {
      });
    }
  }, [allCategories])

  useEffect(() => {
    if (allDescription.length < 1) {
      getAllDescription((callback) => {
        if (callback.status === 200) {
        setAllDescription([...callback.data, { expenseDescriptionId: "other", expenseDescription: "Other" }]);
 }
      }, (onErr) => {
      });
    }
  }, [allSubCategory])

  const handlepagechange = (id) => {
    setTab(id);
    setActiveSort("");
    setActiveFilter("");
    
    if((id === "maped") || (id === "unMaped")){
      setLoader(true);
      getTransactionMapping(id,(callback)=>{
        if(callback.status === 200){

          setAllTransactions(callback.data);
        }
        setLoader(false);
      },(onErr)=>{
        setLoader(false);
      });
    }else{
      filterData();

    }
  }

  const handleFileUpload = (payload) => {

    setLoader(true);
    addTransactionCsvFile(payload, (callback) => {
      setLoader(false);
      if (callback.status === 200) {
        setShowUploadCsv(false);
        alert("File Uploaded Successfully");
        filterData();
      } else {
        alert(`Failed : ${callback?.data ?? "Try again"}`);
      }
    }, (onErr) => {
      alert(`Failed : Try again`);
      setLoader(false);
    });
  }


  return (
    <>
      {loader && <SpinnerLoader />}

      <div className="container-fluid" style={{ position: "relative" }}>
        <h4 style={{ color: "#3F3F3F", fontWeight: '700', textAlign: 'left', marginBottom: '16px' }}>Search Transaction Log</h4>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: "flex-start", flexWrap: "wrap", gap: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', padding: '8px 16px', borderRadius: '800px', width: '600px', border: "1.3px solid #3F3F3F" }}>
            <SearchIcon style={{ marginRight: '8px', color: '#212529' }} />

            <input
              type="text"
              className="form-control"
              placeholder="Search"
              style={{ flex: 1, border: '0', boxShadow: 'none', background: 'transparent' }}
              value={searchTerm}
              onChange={(e) => handleSearchText(e.target.value)}
            />

            {searchTerm && (
              <button
                onClick={clearSearch}
                className="btn btn-link text-dark text-decoration-none p-0 ms-2"
              >
                <CloseIcon style={{ color: '#212529' }} />
              </button>
            )}
          </div>



<div class="csv-button" onClick={() => setShowUploadCsv(true)} style={{ marginLeft: '100px' }}>
            <svg class="csv-button-icon" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            </svg>
            Add
          </div>
        </div>
      </div>

      <div className="container-fluid" style={{ marginTop: '1rem' }}>
        <div className="row">
          <div className="col-md-6 col-sm-12" style={{ marginBottom: '16px' }}>
            <div style={{ textAlign: 'left' }}>
              <div style={{ margin: '8px 0', fontSize: '14px' }}>
                <SortIcon style={{ marginRight: '4px', color: '#212529' }} />
                <strong>Filter transactions log by Type</strong>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                {filterOptions && filterOptions.map((option) => (
                  <button
                    key={option}
                    className={`btn ${activeFilter === option ? "btn-primary" : "btn-outline-secondary"} btn-sm`}
                    onClick={() => setActiveFilterValue(option)}
                    style={{
                      background: activeFilter === option ? "#263145" : '#f8f9fa',
                      border: activeFilter === option ? "1px solid #263145" : ' 1px solid  #f8f9fa',
                      color: activeFilter === option ? "white" : 'black',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                      if (activeFilter !== option) {
                        e.target.style.background = '#263145';
                        e.target.style.color = 'white';
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (activeFilter !== option) {
                        e.target.style.background = '#f8f9fa';
                        e.target.style.color = 'black';
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = 'none';
                      }
                    }}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Sort Section */}
          <div className="col-md-6 col-sm-12" style={{ marginBottom: '16px' }}>
            <div className="">
              <div style={{ textAlign: "left", margin: '8px 0', fontSize: '14px' }}>
                <FilterAltIcon style={{ marginRight: '4px', color: '#212529' }} />
                <strong>Sort transactions log by</strong>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                {sortOptions.map((option) => (
                  <button
                    key={option}
                    className={`btn ${activeSort === option ? "btn-primary" : "btn-light"} btn-sm`}
                    onClick={() => setActiveSortValue(option, null)}
                    style={{
                      background: activeSort === option ? "#263145" : '#f8f9fa',
                      border: activeSort === option ? "1px solid #263145" : '1px solid #f8f9fa',
                      color: activeSort === option ? "white" : 'black',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                      if (activeSort !== option) {
                        e.target.style.background = '#263145';
                        e.target.style.color = 'white';
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (activeSort !== option) {
                        e.target.style.background = '#f8f9fa';
                        e.target.style.color = 'black';
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = 'none';
                      }
                    }}
                  >
                    {option}
                  </button>
                ))}
                <NorthIcon style={{ cursor: "pointer", marginLeft: '8px', color: '#0d6efd' }} onClick={() => setActiveSortValue(activeSort, "desc")} />
                <SouthIcon style={{ cursor: "pointer", color: '#0d6efd' }} onClick={() => setActiveSortValue(activeSort, "asc")} />
              </div>
            </div>
          </div>
        </div>
      </div>


      <div style={{
        position: 'fixed',
        right: window.innerWidth > 1800 ? "5px" :'10px',
        top: window.innerWidth > 1800 ? "40%" :'55%',
        transform: 'translateY(-50%)',
        zIndex: '15'
      }}>
        {transactionSideTabs.map((item) => {
          return (
            <div key={item.id} className='topTabs' style={{...TopTabStyle}}>
              <div
                className="tabs"
                style={tab === item.id ? activeTabStyle : tabStyle}
                onClick={() => handlepagechange(item.id)}
              >
                <h5 style={h5Style}>{item.label}</h5>
              </div>
            </div>
          )
        })}
      </div>


      <div style={{
        ...tabelStyles.tableContainer,
        position: 'relative',
        zIndex: '1',
        marginRight: '50px',
        marginTop: '50px',
        maxHeight:"650px",
      }}>
        <table style={tabelStyles.table}>
          <thead style={{ position: "sticky", top: 0, left: 0 }}>
            <tr style={tabelStyles.tableTitleStyle}>
              <td style={{ textAlign: 'center', padding: '14px 8px' }}>Date</td>
              <td style={{ textAlign: 'center', padding: '14px 8px' }}>Type</td>
              <td style={{ textAlign: 'center', padding: '14px 8px' }}>Category</td>
              <td style={{ textAlign: 'center', padding: '14px 8px' }}>Amount</td>
              <td style={{ textAlign: 'center', padding: '14px 8px' }}>Detail</td>
              <td style={{ textAlign: 'center', padding: '14px 8px' }}>Balance</td>
              <td style={{ textAlign: 'center', padding: '14px 8px' }}>Effective Date</td>
              <td style={{ textAlign: 'center', padding: '14px 8px' }}>Action</td>
            </tr>
          </thead>

          <tbody>
            {allTransactions.map((item, index) => {
              return (
                <tr key={item?.transctionId || index} style={{ padding: "4rem 0" }}>
                  <td style={{ textAlign: 'center', padding: '10px 8px' }}>{item?.date ?? ""}</td>
                  <td style={{ textAlign: 'center', padding: '10px 8px' }}>{item?.debit ? "Expense" : "Income"}</td>
                  <td style={{ textAlign: 'center', padding: '10px 8px' }}>{item?.category ?? ""}</td>
                  <td style={{ textAlign: 'center', padding: '10px 8px' }}>₹ {item?.debit ? (item?.debitAmount || "") : (item?.creditAmount || "")}</td>
                  <td style={{ textAlign: 'center', padding: '10px 8px' }}>{item?.particulars || ""}</td>
                  <td style={{ textAlign: 'center', padding: '10px 8px' }}>₹ {""}</td>
                  <td style={{ textAlign: 'center', padding: '10px 8px' }}>{""}</td>
                  <td style={{ textAlign: 'center', padding: '10px 8px' }} onClick={() => handleSelectedItem(item)}>
                    {(item.category === null || item.subCategory === null || item.description === null) ?
                      <AddBoxIcon style={{ cursor: "pointer", color: '#0d6efd', fontSize: '28px' }} /> : <X style={{ cursor: "not-allowed", color: 'red', fontSize: '28px' }} />}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
      {showUploadCsv &&
        <div className="">
          <div className="background-blur"></div>
          <div className="popup-main container-fluid w-100" style={{ backgroundColor: "transparent", boxShadow: "none", display: "flex", alignItems: "end", justifyContent: "center", maxWidth: "700px" }}>
            <div style={{ backgroundColor: "transparent", boxShadow: "none", display: "block", alignItems: "center", width: "100%" }}
            >
              {!loader &&
                <UploadCsv loader={loader} submitHandler={handleFileUpload} closeHandler={() => setShowUploadCsv(false)} />
              }
            </div>
          </div>
        </div>
      }

      {showPoup &&
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          backgroundColor: "rgba(128, 128, 128, 0.5)",
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 999,
          overflow: "hidden"
        }}>
          <div style={{
            padding: "2rem",
            backgroundColor: "white",
            borderRadius: "12px",
            width: "400px",
            maxWidth: "90%",
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)"
          }}>
            <div style={{
              marginBottom: "1.8rem",
              textAlign: "center"
            }}>
              <h3 style={{
                margin: "0 0 0.5rem 0",
                color: "#333",
                fontSize: "1.8rem",
                fontWeight: "600"
              }}>Add Transaction Details</h3>
              <p style={{
                margin: "0",
                color: "#666",
                fontSize: "1rem"
              }}>Please select the following details</p>
            </div>

            {selectedItem?.category === null &&
              <div style={{ marginBottom: "1.2rem" }}>
                <label style={transactionPopupStyle.label}>Category</label>
                <select
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  style={transactionPopupStyle.dropdownSelect}
                  onFocus={(e) => e.target.style.borderColor = "#0d6efd"}
                  onBlur={(e) => e.target.style.borderColor = "#ddd"}
                >
                  <option value="">Select Category</option>
                  {allCategories.map((category) => (
                    <option key={category.categoryId} value={category?.categoryId ?? ""}>{category.categoryName}</option>
                  ))}
                </select>
              </div>
            }

            {selectedItem?.subCategory === null &&
              <div style={{ marginBottom: "1rem" }}>
                <label style={transactionPopupStyle.label}>Subcategory</label>
                <select
                  value={selectedSubcategory}
                  onChange={(e) => setSelectedSubcategory(e.target.value)}
                  style={transactionPopupStyle.dropdownSelect}
                  onFocus={(e) => selectedCategory && (e.target.style.borderColor = "#0d6efd")}
                  onBlur={(e) => e.target.style.borderColor = "#ddd"}
                >
                  <option value="">Select Subcategory</option>
                  {allSubCategory && allSubCategory?.map((subcategory) => (
                    <option key={subcategory.subCategoryId} value={subcategory.subCategoryId}>{subcategory.subCategoryName}</option>
                  ))}
                </select>
              </div>}

            {selectedItem?.description === null &&
              <div style={{ marginBottom: "2rem" }}>
                <label style={transactionPopupStyle.label}>Description</label>
                <select
                  value={selectedDescription}
                  onChange={(e) => setSelectedDescription(e.target.value)}
                  style={transactionPopupStyle.dropdownSelect}
                  onFocus={(e) => e.target.style.borderColor = "#0d6efd"}
                  onBlur={(e) => e.target.style.borderColor = "#ddd"}
                >
                  <option value="">Select Description</option>
                  {allDescription.map((description) => (
                    <option key={description.expenseDescriptionId} value={description.expenseDescriptionId}>{description.expenseDescription}</option>
                  ))}
                </select>
              </div>}
            {selectedDescription === "other" &&
            <>
              <div style={{ marginBottom: "1rem" }}>
                <input
                  type="text"
                  placeholder="Enter the description here"
                  value={inputDescription}
                  onChange={(e) => setInputDescription(e.target.value)}
                  style={transactionPopupStyle.dropdownSelect}
                  onFocus={(e) => (e.target.style.borderColor = "#0d6efd")}
                  onBlur={(e) => (e.target.style.borderColor = "#ddd")}
                />
              </div>
              <div style={{ marginBottom: "2rem" }}>
              <label style={transactionPopupStyle.label}>Expense Cycle</label>
                <select
                  value={expenseCycle}
                  onChange={(e) => setExpenseCycle(e.target.value)}
                  style={transactionPopupStyle.dropdownSelect}
                  onFocus={(e) => e.target.style.borderColor = "#0d6efd"}
                  onBlur={(e) => e.target.style.borderColor = "#ddd"}
                >
                  <option value="">Select Cycle</option>
                  
                    <option onClick={()=>setExpenseCycle("monthly")}>Monthly</option>
                    <option onClick={()=>setExpenseCycle("yearly")}>Yearly</option>
                  
                </select>
              </div>
              </>
            }


            <div style={{
              display: "flex",
              gap: "0.75rem",
              justifyContent: "center"
            }}>
              <button
                className='btn btn-danger'
                onClick={() => { setShowPoup(false); clearFields() }}
              >
                Cancel
              </button>
              <button
                className='btn btn-primary'
                disabled={!validPopupData()}
                style={{ backgroundColor: "#006C67" }}
                onClick={() => saveCategory()}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default TransactionScreen